import * as React from 'react';
import { TeamsCard } from './teamsCard/TeamsCard';
import { inject, observer } from 'mobx-react';
import { TeamsStore } from './stores';
import * as styles from "./Teams.css";
import { Helper } from '../../Helper';
import TeamsService from '../../services/TeamsService';
import { LocalizationService } from '../../services/LocalizationService';

export interface ITeamsProps {
  teamsStore?: TeamsStore;
}

export interface ITeamsState {
  cards: JSX.Element[];
}

@inject('teamsStore')
@observer
export class Teams extends React.Component<ITeamsProps, ITeamsState> {

  private id: string;

  constructor(props: ITeamsProps) {
    super(props);
    this.state = {
      cards: []
    }
    this.id = Helper.getRandomStringKey();
    this.getPosts();
  }

  private getPosts(): void {
    TeamsService.getPosts(this.props.teamsStore.environment, this.props.teamsStore.token, this.props.teamsStore.tenant).then((posts: any) => {
      let cards = [];
      this.props.teamsStore.posts = posts != undefined ? posts : [];
      if (posts != undefined && posts.length != undefined) {
        posts.forEach((post: any, index) => {
          if (this.props.teamsStore.numCards > index) {
            cards.push(
              <TeamsCard
                id={post.id}
                key={post.id}
                text={post.text}
                subject={post.subject}
                author={post.author}
                date={post.date}
                team={post.team}
                channel={post.channel}
                tenant={post.tenant}
                reactions={post.reactions.length}
                replies={undefined}
                highlightedComments={undefined}
              />
            );
          }
        });
      }
      this.setState({ cards });
      this.forceUpdate();
    });
  }

  public componentWillReceiveProps(props: ITeamsProps): void {
    if (props.teamsStore.numCards !== this.props.teamsStore.numCards) {
      this.getPosts();
    }
  }

  public componentDidMount(): void {
    window.addEventListener('resize', () => this.resize());
    this.resize();
  }

  private resize(): void {
    let cardContainer: any = document.getElementById(`cardContainer_${this.id}`);
    this.props.teamsStore.containerWidth = cardContainer.offsetWidth;
    let maxAmountOfCards = Math.floor(this.props.teamsStore.containerWidth / (214 + 20));
    maxAmountOfCards = maxAmountOfCards > 4 ? 4 : maxAmountOfCards;
    this.props.teamsStore.cardWidth = ((this.props.teamsStore.containerWidth - (maxAmountOfCards * 20)) / maxAmountOfCards) - 4;
    console.log(this.props.teamsStore.cardWidth);
  }

  render() {
    return (
      <div
        className={styles.IA_cardsContainer}
        id={`cardContainer_${this.id}`}
      >
        <div
          className={styles.IA_title}
        >
          {this.props.teamsStore.title}
        </div>
        {this.props.teamsStore.posts != undefined && this.props.teamsStore.posts.length > 0 &&
          this.state.cards
        }
        {this.props.teamsStore.posts != undefined && this.props.teamsStore.posts.length == 0 &&
          <div style={{ 
            color: "#999999",
            fontSize: 12,
            marginTop: 20,
            fontWeight: "lighter"
          }}>
            {new LocalizationService().strings.Teams_NoContent}
          </div>
        }
      </div>
    )
  }

  public componentWillUnmount(): void {
    window.removeEventListener('resize', () => this.resize());
  }
}
